import {useEffect, useState} from 'react';

export const useKeyState = (
    keyCode: KeyboardEvent['key'],
    modifier: 'altKey' | 'ctrlKey' | 'shiftKey' | 'noModifier' = 'noModifier'
) => {
    const [pressed, setPressed] = useState(false);
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (
                event.key === keyCode &&
                (modifier !== 'noModifier' ? event[modifier] : !event.ctrlKey && !event.altKey && !event.metaKey)
            ) {
                setPressed(true);
            }
        };
        const handleKeyUp = (event: KeyboardEvent) => {
            if (
                event.key === keyCode &&
                (modifier !== 'noModifier' ? event[modifier] : !event.ctrlKey && !event.altKey && !event.metaKey)
            ) {
                setPressed(false);
            }
        };

        const forceUnpressed = () => setPressed(false);

        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);
        window.addEventListener('blur', forceUnpressed);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
            window.removeEventListener('blur', forceUnpressed);
        };
    }, [keyCode, modifier]);

    return pressed;
};
